<script>
    export let link;
    export let linkTitle;

    function toggleMenu() {
        document.querySelector('.menu').classList.remove('active');
        document.querySelector('.menu__toggler').classList.remove('active');
    }
</script>

<li class="menu-items" on:click={toggleMenu}><a href={link}>{linkTitle}</a></li>